<app-navbar></app-navbar>
<app-sidebar *ngIf="showSideBar"></app-sidebar>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div [ngClass]="{container: showSideBar, adjust: (!showSideBar) && isLoggedIn}">
    <router-outlet />
</div>
